module.exports = require("ramda/src/assoc");